module.exports = __webpack_public_path__ + "static/media/map events icon.89913118.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/map events icon.svg
// module id = 853
// module chunks = 0